import React, { PureComponent, Fragment } from 'react';

import { navigateToEpisodePage } from '../../../components/nav/EpisodeLink';

import {
  SettingsChangeListener,
  SettingsEventListener,
} from '../../../components/context/settings';

import getFeedUrl from '../../../lib/settings/getFeedUrl';

import { SettingsPubSubEvent } from '@wix/podcasts-common/dist/settings';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import { WidgetPage } from '@wix/podcasts-common/dist/widget';

import { ISettings } from '../../../lib/settings/types';
import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';
import { getEpisodesPerPage } from '../../../selectors/settings';
import { IWithTPAProps, withTPA } from '../../../components/context/tpa';

function isCriticalSettingsChanged(
  settings: ISettings,
  prevSettings: ISettings,
  deviceType: TPADeviceType,
) {
  const pageWidth = window.innerWidth;
  return (
    getFeedUrl(settings) !== getFeedUrl(prevSettings) ||
    getEpisodesPerPage(settings, deviceType, pageWidth) !==
      getEpisodesPerPage(prevSettings, deviceType, pageWidth)
  );
}

interface IMainPageOnSettingsEvents extends IWithTPAProps {
  episodes: IPodcastEpisode[];
}

class MainPageSettingsListener extends PureComponent<IMainPageOnSettingsEvents> {
  onSettingsChanged = (settings: ISettings, prevSettings: ISettings) => {
    const { deviceType } = this.props.tpa.params;
    if (isCriticalSettingsChanged(settings, prevSettings, deviceType)) {
      // @ts-expect-error
      window.location.reload(true);
    }
  };

  onSettingsPageChanged = (data: { page: WidgetPage }) => {
    if (
      data.page === WidgetPage.EPISODE &&
      this.props.episodes &&
      this.props.episodes.length
    ) {
      const episode = this.props.episodes[0];

      navigateToEpisodePage(episode.id, episode.slug);
    }
  };

  render() {
    return (
      <Fragment>
        <SettingsChangeListener onChanged={this.onSettingsChanged} />
        <SettingsEventListener
          event={SettingsPubSubEvent.WIDGET_PAGE_CHANGE}
          onEvent={this.onSettingsPageChanged}
        />
      </Fragment>
    );
  }
}

export default withTPA(MainPageSettingsListener);
